<lms-dynamic-form [questions]="questions" [options]="{ hideSubmit: true }" (change)="onChange($event)">
  <ng-content select="[form-actions-after]" form-actions-after></ng-content>
</lms-dynamic-form>

<gl-button
  color-primary
  [disabled]="submitDisabled"
  (onClick)="submit()"
  form-actions-after
  [ngClass]="{ tooltipDisabled: submitDisabled }"
  title="{{ submitDisabled ? 'actions.fillForm' : ('actions.save' | translate) }}"
  text="{{ submitDisabled ? 'actions.fillForm' : ('actions.save' | translate) }}"
>
  {{ 'actions.save' | translate }}
</gl-button>
